import { useUser } from "@/app/context/UserContext";
import React, { useEffect, useRef, useState } from "react";
import { Check, CircleX, FilePlus2, FileQuestion, FileText, MoreVertical} from "lucide-react";
import { iProProjectMain } from "@/app/models/interfaceProject";
import { chatbotMyDocs } from "@/app/services/chatbotmydocs";
import UploadModal from "../UploadModal/UploadModal";
import { saveAs } from 'file-saver';
import Loading from "../Elements/Loading";
import { iMyDocFileData } from "@/app/models/interfaceMyDocFileData";
import { chatbotMyDocsFileDataDelete, chatbotMyDocsFileDataDowload } from "@/app/services/chatbotMyDocsFileData";
import { getExtensionFromMimeType } from "@/app/helpers/getExtensionFromMimeType";
import Tooltip from "../Elements/Tooltip";
import { Action, LOCAL_ICON_COLOR, OriginFile, StatusFile, TypeFile, TypeLayout } from "@/app/constants/enums";
import InputChat from "../Elements/Core/InputChat";
import ButtonChat from "../Elements/Core/ButtonChat";
import { DriveFileIcon } from "../Elements/Icon/DriveFileIcon";

const ListSourceView = () => {
  const { user, setUser, 
          userLoading, setUserLoading,
          userLoaded, setUserLoaded,
          userProject,setUserProject,
          userProjectLoading, setUserProjectLoading,
          typeLayout, setTypeLayout,
          myDocs, setMyDocs,
          myDocsLoading, setMyDocsLoading } = useUser();// Accedemos al usuario logueado desde el contexto
  
  const [isModalOpenFile, setIsModalOpenFile] = useState(false);
  
  const closeModalFile = () => setIsModalOpenFile(false);
 
  // Carga My Doc
  const fetchDataMyDoc = async () => { 
    setMyDocsLoading(true);
    if (userLoaded && user!=null && !user.isAnonymous) {
      try { 
        const response = await chatbotMyDocs(user, setUser);   
        if(response.success && response.code == 200){
          setMyDocs(response.data);
        }else {
          setMyDocs(null);
        } 
      } catch (error) { 
        setMyDocs(null); 
      } finally { setMyDocsLoading(false);} 
    }
  } 

 // servicio Mys docs
useEffect(() => { 
  if(user &&typeLayout==TypeLayout.Personal){
    fetchDataMyDoc(); 
  } 
}, [user?.email, userLoaded]);

       
    // My Document
      
 

//-****** my docs
    const [activeMenu, setActiveMenu] = useState<string | null>(null);
    const menuRef = useRef<HTMLDivElement>(null);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [deleted, setDeleted] = useState<any>(0);
    const [download, setDownload] = useState<any>(0);
    
    
    const [myDocFileData, setMyDocFileData] = useState<iMyDocFileData | null>(null);

    const toggleMenu = (fileId: string) => {
      setActiveMenu((prev) => (prev === fileId ? null : fileId));
      setLoadingDownload(false);
      setDownload(0); 
      setDeleted(0);
    };

    const handleAdd = () =>  {
      setMyDocFileData(null);
      setIsModalOpenFile(true); 
    } ; 

    const handleEdit = (doc: any) => {
      setMyDocFileData(doc);
      setIsModalOpenFile(true); 
      // Lógica para editar
    };

    const handleDownload = async (doc: any) => {

      try { 
        setLoadingDownload(true); 
        const response = await chatbotMyDocsFileDataDowload(doc,user,setUser);   
        if(response.success && response.code == 200){
          if(response.data instanceof Blob){
            saveAs(response.data, `${(doc.name).substring(150)}.${ getExtensionFromMimeType(response.data.type)}`);
            setDownload(1); 
          }else{
            console.error("Error al descargar el archivo:"); 
            setDownload(2); 
          } 
        }else{
          console.error("Error al descargar el archivo"); 
          setDownload(2); 
        }
      } catch (error) { 
        console.error("Error al descargar el archivo:", error); 
        setDownload(2); 
      }
      finally { 
        setLoadingDownload(false); 
      }  
    };

    const handleDelete = async (doc: any) => {
      try { 
        setLoadingDelete(true); 
        const response = await chatbotMyDocsFileDataDelete(doc,user,setUser);   
        if(response.success && response.code == 200){ 
          const updatedDocs = myDocs.filter(item => item.file_id !== doc.file_id); 
          setDeleted(1);
          setTimeout(() => {
            setMyDocs(updatedDocs); 
          },1000); 
        }else{
          setDeleted(2); 
        }
      } catch (error) { 
        console.error("Error al aliminar el archivo:", error); 
        setDeleted(2); 
      }
      finally { 
        setLoadingDelete(false); 
      } 
    };

    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setActiveMenu(null); 
      }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      };
  }, []);
 


  // Selecion de chaeck 
  const handleSelectDocs = (checked: boolean) => {
    setUserProject((prev:iProProjectMain) => ({
      ...prev,
      useDocs: checked,
      useMyDocs: !checked ,
    }));
  };

  const handleSelectMyDocs = (checked: boolean) => {
    setUserProject((prev:iProProjectMain) => ({
      ...prev,
      useMyDocs: checked,
      useDocs: !checked,
    }));
  };

  return ( 
    <div> 
        <div  className={`w-full h-full p-4`}> 
        
        <div className="m-0 ml-2 mr-2  ">
            <label className="flex justify-between items-center w-full cursor-pointer border-b py-2">
            <span className="truncate max-w-[90%] hover:text-blue-700 font-semibold">Fuentes
            </span> 
            {typeLayout==TypeLayout.Personal?
              <InputChat
                actionCode={Action.LEFT_FUENTE} 
                type="checkbox"                
                checked={userProject?.useDocs ?? false} 
                onChange={(e) => handleSelectDocs(e.target.checked)}
                className="h-5 w-5 text-blue-600 rounded flex-shrink-0 focus:outline-none focus:ring-1 focus:ring-blue-700" />
                :""
            }
            
                
            </label> 
            
            { userLoading ? 'loading...' :             
            <> 
                {userProject.qa.length?
                  <label key={0} className="flex justify-between items-center w-full cursor-pointer py-2">
                  <div className="flex items-center space-x-2 max-w-[85%]">
                  <FileQuestion strokeWidth={1} className={`text-blue-500 w-6 h-6 flex-shrink-0`} />
                  <span className={`truncate hover:text-blue-700 `} >
                      <Tooltip text={ `${userProject.qa.length} Preguntas y Respuestas`  }>
                        {userProject.qa.length} Preguta(s) y Respuesta(s)
                      </Tooltip>
                  </span>
                  </div>
                  
              </label>
                :""} 

                {userProject?.docs?.map((doc) => (
                <label key={doc.file_id} className="flex justify-between items-center w-full cursor-pointer py-2">
                    <div className="flex items-center space-x-2 max-w-[85%]">
                    {doc?.file_origin==OriginFile.Drive? 
                      <DriveFileIcon size={22} className={LOCAL_ICON_COLOR[(doc?.type??"") as TypeFile]??"text-gray-500"}/>
                      :
                      <FileText size={22} className={LOCAL_ICON_COLOR[(doc?.type??"") as TypeFile]??"text-gray-500"}/>
                    }


                    <span className={`truncate hover:text-blue-700 `} >
                        <Tooltip text={(doc.status === StatusFile.Created? "Procesando " :"") + doc.name}>
                        {doc.name}
                        </Tooltip>
                    </span>
                    </div> 
                    {doc.status === StatusFile.Created? <Loading w="w-2" h="h-2" className=""/> :""}
                    
                </label>
                ))          
              }
            </> 
            } 

            
            {(typeLayout!==TypeLayout.Personal)&& (!user.isAnonymous) ?'':
          
            <div>
              { user.isAnonymous ?'':
                <label className="flex justify-between items-center w-full cursor-pointer border-b py-2 pt-5">
                    <span className="truncate max-w-[90%] hover:text-blue-700 font-semibold">
                    Mis Fuentes
                    </span>
                    
                    <div className="flex items-center"> 
                    <InputChat
                        actionCode={Action.LEFT_MY_DOC} 
                        type="checkbox"  
                        checked={userProject?.useMyDocs ?? false} 
                        onChange={(e) => handleSelectMyDocs(e.target.checked)}
                        className="h-5 w-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-300 flex-shrink-0 ml-5" 
                    />
                    <ButtonChat
                        actionCode={Action.LEFT_MY_DOC_ADD}
                        type="button"
                        onClick={handleAdd}
                        className="ml-3 rounded-full text-blue-700 hover:bg-slate-200 transition duration-150 ease-in-out flex-shrink-0 -m-2 ">
                        <FilePlus2 strokeWidth={1} className="m-2" />
                    </ButtonChat> 
                    </div>
                </label>
              }
  
              {user && !user.isAnonymous && (
              myDocsLoading ? (
                  'loading...'
              ) :  myDocs?.map((doc: any) => (
                  <label
                  key={doc.file_id}
                  className={` flex justify-between items-center w-full cursor-pointer py-2 ${doc.filename ? "" : "hidden"}`}
                  >
                      

                  {/* Contenido izquierdo: texto e ícono */}
                  <span className="flex items-left max-w-[80%] ">
                      {doc?.file_origin==OriginFile.Drive? 
                        <DriveFileIcon size={22} className={LOCAL_ICON_COLOR[(doc?.type??"") as TypeFile]??"text-gray-500"}/>
                        :
                        <FileText size={22} className={LOCAL_ICON_COLOR[(doc?.type??"") as TypeFile]??"text-gray-500"}/>
                      } 
                      <span className="truncate w-full hover:text-blue-700">
                      <Tooltip text={doc.name}>
                          {doc.name}
                      </Tooltip>
                      </span>
                  </span>

                  {/* Contenido derecho: checkbox y menú en columna */}
                  <div className="flex items-right max-w-[20%] ">
                       
                      {/* Menú de tres puntos */}
                      <div className=" mr-5"
                          onMouseDown={(e) => e.stopPropagation()} // Evita que el clic dentro del menú lo cierre
                      >
                      <ButtonChat
                          actionCode={Action.LEFT_MY_DOC_MENU}
                          className="absolute rounded-full text-blue-700 hover:bg-slate-200 transition duration-150 ease-in-out -mt-2"
                          onClick={() => toggleMenu(doc.file_id)}
                      >
                          <MoreVertical strokeWidth={1.5} className="m-2" />
                      </ButtonChat>

                      {/* Menú desplegable */}
                      {activeMenu === doc.file_id && (
                          <div                         
                          key={doc.file_id+"menu"}                     
                          ref={menuRef} 
                          className={`
                          absolute right-0 mt-5 w-40 bg-white border border-gray-300 rounded-lg shadow-lg z-10
                          transition-all duration-300 ease-in-out
                          ${activeMenu !== doc.file_id ? "animate-fadeOut" : "animate-fadeIn"}
                          `}
                          
                          >
                          <ButtonChat
                              actionCode={Action.LEFT_MY_DOC_EDIT}
                              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                              onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(doc);
                              }}
                          >
                              Editar
                          </ButtonChat>
                          <ButtonChat
                              actionCode={Action.LEFT_MY_DOC_DOWNLOAD}
                              className="flex justify-between w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" 
                              disabled={download!=0}
                              onClick={(e) => {
                              e.stopPropagation();
                              handleDownload(doc);
                              }}
                          >
                              Descargar
                              {loadingDownload&&(
                              <Loading w="w-2" h="h-2" className="ml-auto"/> 
                              ) }
                              {download==1&&(<Check strokeWidth={0.8} />)}
                              {download==2&&(<CircleX strokeWidth={0.8} />)} 
                          </ButtonChat>
                          <ButtonChat
                              actionCode={Action.LEFT_MY_DOC_DELETE}
                              className="flex justify-between w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" 
                              disabled={deleted!=0}
                              onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(doc);
                              }}
                          >
                              Eliminar
                              {loadingDelete&&(
                              <Loading w="w-2" h="h-2" className="ml-auto"/> 
                              ) }
                              {deleted==1&&(<Check strokeWidth={0.8} />)}
                              {deleted==2&&(<CircleX strokeWidth={0.8}/>)}
                          </ButtonChat>
                          </div>
                      )}
                      </div>
                  </div>





                  </label>
              ))
              )}

            </div>
            }
 
        </div>


        </div>
        {isModalOpenFile&&(<UploadModal isOpen={isModalOpenFile} onClose={closeModalFile} myDoc={myDocFileData}/>
        )}
      
    </div>
  );
};

export default ListSourceView;